module.exports = {
      id: "follow-usage",
      viewBox: "0 0 129 42",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#follow",
      toString: function () {
        return this.url;
      }
    }